import axios from "axios";
import { APIHost } from "./helpers";

// Base URL
export const baseURL = (type = "") => {
  return APIHost() + `:3106${type === "all" ? "/all" : "/consumer"}`;
};

//
export const mallLoadShopDetails = (shopID, params) => {
  const url = `${baseURL("all")}/shop/getShopList${
    shopID !== null ? "/" + shopID : ""
  }`;

  return axios.post(url, params);
};
